/**
 * DutyStatusBadge
 * Small inline badge showing a pilot's overall duty time status.
 * For use in tables, lists, and KPI cards.
 */

interface DutyStatusBadgeProps {
  overallStatus: 'green' | 'amber' | 'red';
  alertCount?: number;
  size?: 'sm' | 'md';
}

export default function DutyStatusBadge({ overallStatus, alertCount, size = 'sm' }: DutyStatusBadgeProps) {
  const dotSize = size === 'sm' ? 'w-2 h-2' : 'w-2.5 h-2.5';
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';

  const config = {
    green: { dot: 'bg-success', text: 'text-success', label: 'OK' },
    amber: { dot: 'bg-warning', text: 'text-warning', label: 'Warning' },
    red: { dot: 'bg-danger', text: 'text-danger', label: 'Alert' },
  }[overallStatus];

  return (
    <span className={`inline-flex items-center gap-1.5 ${textSize} font-medium ${config.text}`}>
      <span className={`${dotSize} rounded-full ${config.dot}`} />
      {config.label}
      {alertCount !== undefined && alertCount > 0 && (
        <span className="text-muted-foreground font-normal">({alertCount})</span>
      )}
    </span>
  );
}
